import { deleteAuthorizationToken, setAuthorizationToken } from '../utils/Auth';
import { SignInCredentials } from '../types/Auth';
import { api } from './api';

export async function auth(data: SignInCredentials) {
  try {
    const response = await api.post('/auth/login', data);

    if (response.data.token) {
      setAuthorizationToken(response.data.token);
      return response.data;
    }

    if (response.data.qr_code) {
      return response.data;
    }

  } catch(error) {
    throw error;
  }
}

export async function leave() {
  try {
    deleteAuthorizationToken();
    await api.post('/auth/logout');
  } catch (error) {
    throw error;
  }
}

export async function authenticatedUser() {
  try {
    const response = await api.get('/me');
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getTokenUser(user_id: string) {
  try {
    const response = await api.get('/auth/token-user/' + user_id);
    return response.data;
  } catch (error) {
    throw error
  }
}